import { capitalizeFirstLetter } from './api';

export const formatPriority = (priority) => {
  if (!priority) return 'No Priority';
  return priority
    .split('_')
    .map(capitalizeFirstLetter)
    .join(' ');
};
